var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "a-tab-pane",
            { key: "list", attrs: { tab: "模板列表" } },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { md: 24 } },
                    [
                      _c(
                        "a-card",
                        { attrs: { bordered: false } },
                        [
                          _c(
                            "div",
                            { staticClass: "table-page-search-wrapper" },
                            [
                              _c(
                                "a-form",
                                {
                                  attrs: { layout: "inline" },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.searchQuery.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a-row",
                                    { attrs: { gutter: 24 } },
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            { attrs: { label: "模板名称" } },
                                            [
                                              _c("a-input", {
                                                attrs: {
                                                  placeholder: "请输入模板名称",
                                                  allowClear: "",
                                                },
                                                model: {
                                                  value: _vm.query.templateName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.query,
                                                      "templateName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "query.templateName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            { attrs: { label: "单据类型" } },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder: "请选择",
                                                    allowClear: "",
                                                  },
                                                  model: {
                                                    value: _vm.query.billType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.query,
                                                        "billType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "query.billType",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: {
                                                        value: "purchase_apply",
                                                      },
                                                    },
                                                    [_vm._v("请购单")]
                                                  ),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: {
                                                        value: "purchase_order",
                                                      },
                                                    },
                                                    [_vm._v("采购订单")]
                                                  ),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: {
                                                        value: "purchase_in",
                                                      },
                                                    },
                                                    [_vm._v("采购入库")]
                                                  ),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: {
                                                        value: "sales_order",
                                                      },
                                                    },
                                                    [_vm._v("销售订单")]
                                                  ),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: {
                                                        value: "sales_out",
                                                      },
                                                    },
                                                    [_vm._v("销售出库")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { md: 6, sm: 24 } },
                                        [
                                          _c(
                                            "a-form-item",
                                            { attrs: { label: "状态" } },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    placeholder: "全部",
                                                    allowClear: "",
                                                  },
                                                  model: {
                                                    value: _vm.query.enabled,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.query,
                                                        "enabled",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "query.enabled",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select-option",
                                                    { attrs: { value: 1 } },
                                                    [_vm._v("启用")]
                                                  ),
                                                  _c(
                                                    "a-select-option",
                                                    { attrs: { value: 0 } },
                                                    [_vm._v("禁用")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            float: "left",
                                            overflow: "hidden",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { md: 12, sm: 24 } },
                                            [
                                              _c(
                                                "a-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    icon: "search",
                                                  },
                                                  on: {
                                                    click: _vm.searchQuery,
                                                  },
                                                },
                                                [_vm._v("查询")]
                                              ),
                                              _c(
                                                "a-button",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "8px",
                                                  },
                                                  attrs: { icon: "reload" },
                                                  on: {
                                                    click: _vm.searchReset,
                                                  },
                                                },
                                                [_vm._v("重置")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "table-operator",
                              staticStyle: { "margin-top": "10px" },
                            },
                            [
                              _vm.hasBtn(1)
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary", icon: "plus" },
                                      on: { click: _vm.handleAdd },
                                    },
                                    [_vm._v("新增模板")]
                                  )
                                : _vm._e(),
                              _vm.hasBtn(1)
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { icon: "upload" },
                                      on: { click: _vm.handleBatchImport },
                                    },
                                    [_vm._v("从文件导入模板")]
                                  )
                                : _vm._e(),
                              _vm.hasBtn(1)
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: {
                                        icon: "edit",
                                        disabled:
                                          _vm.selectedRowKeys.length === 0,
                                      },
                                      on: { click: _vm.handleBatchEdit },
                                    },
                                    [_vm._v("批量编辑")]
                                  )
                                : _vm._e(),
                              _vm.hasBtn(1)
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: {
                                        icon: "delete",
                                        disabled:
                                          _vm.selectedRowKeys.length === 0,
                                      },
                                      on: { click: _vm.handleBatchDelete },
                                    },
                                    [_vm._v("批量删除")]
                                  )
                                : _vm._e(),
                              _vm.hasBtn(3)
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { icon: "download" },
                                      on: { click: _vm.handleExport },
                                    },
                                    [_vm._v("导出")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("a-table", {
                            attrs: {
                              columns: _vm.columns,
                              dataSource: _vm.dataSource,
                              pagination: _vm.ipagination,
                              loading: _vm.loading,
                              rowKey: (record) => record.id,
                              rowSelection: {
                                selectedRowKeys: _vm.selectedRowKeys,
                                onChange: _vm.onSelectChange,
                              },
                            },
                            on: { change: _vm.handleTableChange },
                            scopedSlots: _vm._u([
                              {
                                key: "billType",
                                fn: function (text) {
                                  return [
                                    _c(
                                      "a-tag",
                                      {
                                        attrs: {
                                          color: _vm.getBillTypeColor(text),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.getBillTypeName(text))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "enabled",
                                fn: function (text, record) {
                                  return [
                                    _c("a-switch", {
                                      attrs: {
                                        checked: text === 1,
                                        disabled: !_vm.hasBtn(4),
                                      },
                                      on: {
                                        change: (checked) =>
                                          _vm.handleToggle(record, checked),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "isDefault",
                                fn: function (text) {
                                  return [
                                    text === 1
                                      ? _c("a-icon", {
                                          staticStyle: { color: "#faad14" },
                                          attrs: {
                                            type: "star",
                                            theme: "filled",
                                          },
                                        })
                                      : _c(
                                          "span",
                                          { staticStyle: { color: "#bbb" } },
                                          [_vm._v("-")]
                                        ),
                                  ]
                                },
                              },
                              {
                                key: "createTime",
                                fn: function (text) {
                                  return [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(_vm.formatDateTime(text)) +
                                        "\n        "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "action",
                                fn: function (text, record) {
                                  return [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDesign(record)
                                          },
                                        },
                                      },
                                      [_vm._v("设计")]
                                    ),
                                    _vm.hasBtn(1)
                                      ? _c("a-divider", {
                                          attrs: { type: "vertical" },
                                        })
                                      : _vm._e(),
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlePreview(record)
                                          },
                                        },
                                      },
                                      [_vm._v("预览")]
                                    ),
                                    _vm.hasBtn(5)
                                      ? _c("a-divider", {
                                          attrs: { type: "vertical" },
                                        })
                                      : _vm._e(),
                                    _vm.hasBtn(1) ||
                                    _vm.hasBtn(4) ||
                                    _vm.hasBtn(6)
                                      ? _c(
                                          "a-dropdown",
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "ant-dropdown-link",
                                              },
                                              [
                                                _vm._v("更多 "),
                                                _c("a-icon", {
                                                  attrs: { type: "down" },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "a-menu",
                                              {
                                                attrs: { slot: "overlay" },
                                                slot: "overlay",
                                              },
                                              [
                                                record.isDefault !== 1 &&
                                                _vm.hasBtn(4)
                                                  ? _c(
                                                      "a-menu-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleSetDefault(
                                                              record
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                设为默认\n              "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.hasBtn(1)
                                                  ? _c(
                                                      "a-menu-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleCopy(
                                                              record
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                复制模板\n              "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c("a-menu-divider"),
                                                _vm.hasBtn(6)
                                                  ? _c(
                                                      "a-menu-item",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleVoid(
                                                              record
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                作废\n              "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.hasBtn(1)
                                                  ? _c(
                                                      "a-menu-item",
                                                      {
                                                        staticStyle: {
                                                          color: "#ff4d4f",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleDelete(
                                                              record
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                删除\n              "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: "批量导入结果",
                    visible: _vm.importResultVisible,
                    footer: null,
                    width: "600px",
                  },
                  on: {
                    ok: function ($event) {
                      _vm.importResultVisible = false
                    },
                    cancel: function ($event) {
                      _vm.importResultVisible = false
                    },
                  },
                },
                [
                  _c("a-alert", {
                    staticStyle: { "margin-bottom": "16px" },
                    attrs: {
                      message: `导入完成：成功 ${_vm.importResult.success} 个，失败 ${_vm.importResult.fail} 个`,
                      description: `总文件数: ${_vm.importResult.totalFiles}，目录: ${_vm.importResult.directory}`,
                      type: _vm.importResult.fail > 0 ? "warning" : "success",
                      "show-icon": "",
                    },
                  }),
                  _vm.importResult.successFiles.length > 0
                    ? _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
                        _c(
                          "h4",
                          {
                            staticStyle: { color: "#52c41a", margin: "8px 0" },
                          },
                          [
                            _vm._v(
                              "成功导入 (" +
                                _vm._s(_vm.importResult.successFiles.length) +
                                ")"
                            ),
                          ]
                        ),
                        _c(
                          "ul",
                          {
                            staticStyle: {
                              "list-style": "none",
                              padding: "0",
                              "max-height": "150px",
                              "overflow-y": "auto",
                            },
                          },
                          _vm._l(
                            _vm.importResult.successFiles,
                            function (file, index) {
                              return _c(
                                "li",
                                {
                                  key: "success-" + index,
                                  staticStyle: {
                                    padding: "2px 0",
                                    color: "#389e0d",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n        ✓ " + _vm._s(file) + "\n      "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm.importResult.failFiles.length > 0
                    ? _c("div", [
                        _c(
                          "h4",
                          {
                            staticStyle: { color: "#ff4d4f", margin: "8px 0" },
                          },
                          [
                            _vm._v(
                              "失败 (" +
                                _vm._s(_vm.importResult.failFiles.length) +
                                ")"
                            ),
                          ]
                        ),
                        _c(
                          "ul",
                          {
                            staticStyle: {
                              "list-style": "none",
                              padding: "0",
                              "max-height": "150px",
                              "overflow-y": "auto",
                            },
                          },
                          _vm._l(
                            _vm.importResult.failFiles,
                            function (file, index) {
                              return _c(
                                "li",
                                {
                                  key: "fail-" + index,
                                  staticStyle: {
                                    padding: "2px 0",
                                    color: "#cf1322",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n        ✗ " + _vm._s(file) + "\n      "
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "margin-top": "16px",
                      },
                    },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.importResultVisible = false
                            },
                          },
                        },
                        [_vm._v("确定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-tab-pane",
            { key: "designer", attrs: { tab: "模板设计" } },
            [
              _vm.designerVisible
                ? _c("TemplateDesignerV2", {
                    attrs: {
                      "template-id": _vm.currentDesignerId,
                      "bill-type": _vm.currentDesignerBillType,
                    },
                    on: {
                      close: _vm.handleDesignerClose,
                      saved: _vm.handleDesignerSaved,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }